import { cva } from 'class-variance-authority';

export const featuredIconVariants = cva('flex items-center justify-center flex-shrink-0 border', {
  variants: {
    size: {
      xxs: 'size-5 rounded-xs',
      xs: 'size-6 rounded-sm',
      sm: 'size-8 rounded-sm',
      md: 'size-10 rounded-lg',
      lg: 'size-12 rounded-lg',
      xl: 'size-14 rounded-xl',
      '2xl': 'size-[3.875rem] rounded-xl',
    },
    color: {
      white: 'bg-white border-tertiary',
      clear: '',
      gray: 'bg-utility-gray-50 border-utility-gray-100',
      brand: 'bg-utility-brand-50 border-utility-brand-100',
      error: 'bg-utility-error-50 border-utility-error-100',
      warning: 'bg-utility-warning-50 border-utility-warning-100',
      success: 'bg-utility-success-50 border-utility-success-100',
      'blue-light': 'bg-utility-blue-light-50 border-utility-blue-light-100',
      blue: 'bg-utility-blue-50 border-utility-blue-100',
      indigo: 'bg-utility-indigo-50 border-utility-indigo-100',
      purple: 'bg-utility-purple-50 border-utility-purple-100',
      violet: 'bg-utility-violet-50 border-utility-violet-100',
      fuchsia: 'bg-utility-fuchsia-50 border-utility-fuchsia-100',
      cyan: 'bg-utility-cyan-50 border-utility-cyan-100',
      lime: 'bg-utility-lime-50 border-utility-lime-100',
      pink: 'bg-utility-pink-50 border-utility-pink-100',
    },
  },
  compoundVariants: [
    {
      color: 'clear',
      className: 'border-none',
    },
  ],
});

export const featuredIconIconVariants = cva('', {
  variants: {
    size: {
      xxs: 'size-3',
      xs: 'size-4',
      sm: 'size-5',
      md: 'size-6',
      lg: 'size-7',
      xl: 'size-8',
      '2xl': 'size-9',
    },
    color: {
      white: 'text-utility-gray-600',
      clear: 'text-utility-gray-600',
      gray: 'text-utility-gray-600',
      brand: 'text-utility-brand-600',
      error: 'text-utility-error-600',
      warning: 'text-utility-warning-600',
      success: 'text-utility-success-600',
      'blue-light': 'text-utility-blue-light-600',
      blue: 'text-utility-blue-600',
      indigo: 'text-utility-indigo-600',
      purple: 'text-utility-purple-600',
      violet: 'text-utility-violet-600',
      fuchsia: 'text-utility-fuchsia-600',
      cyan: 'text-utility-cyan-600',
      lime: 'text-utility-lime-600',
      pink: 'text-utility-pink-600',
    },
  },
});
